<template>
  <div class="wallet">
    <!--头部-->
    <van-nav-bar class="wallet-header"  @click-left="onClickLeft" :border="false">
      <span class="set-icon" slot="right" @click="goWalletSetting"></span>
    </van-nav-bar>
    <div class="header">
      <div class="item">
        <div class="title">总资产 (￥)</div>
        <div class="num">≈ <span class="span">{{ (cashBalance + serviceCashTotalAmount + antCoinMoney) | filter2 }}</span></div>
      </div>
      <div class="item">
        <div class="title">待结算资产 (￥)</div>
        <div class="num">≈ <span class="span">{{ waitSettle | filter2 }}</span></div>
      </div>
    </div>
    <van-tabs class="wallet-tabs" v-model="walletActive" :line-width="75" title-active-color="#2b86cc">
      <van-tab class="wallet-tab" title="钱包">
        <div class="list-con">
          <div class="list list1" @click="goWalletCash('0')">
            <div class="img-con">
              <img class="img" :src="checkQiNiuUrl('FqtrXQtG5csG4p3w_Ekx4R5DwJ0E')" alt="">
            </div>
            <div class="text-con">奖金余额 <span style="display: inline-block;width: 40px;"></span></div>
            <div class="num-con"><p class="sup-num"><span class="num">{{ cashBalance | filter2 }}</span>元</p></div>
          </div>

          <div class="list list4" @click="goWalletCash('2')" v-if="serviceCash">
            <div class="img-con">
              <img class="img" :src="checkQiNiuUrl('FibbdIlCYV8cG-i8bSYEQ5qxSOMh')" alt="">
            </div>
            <div class="text-con">服务余额 <span style="display: inline-block;width: 40px;"></span></div>
            <div class="num-con"><p class="sup-num"><span class="num">{{ serviceCashTotalAmount | filter2 }}</span>元</p></div>
          </div>

          <div class="list list2" @click="goWalletCoin">
            <div class="img-con">
              <img class="img" :src="checkQiNiuUrl('FtQR1wVvjLkdqpP_f9ppNWB9oQU4')" alt="">
            </div>
            <div class="text-con">云柑金币</div>
            <div class="num-con">
              <p class="sup-num"><span class="num">{{ antCoinBalance | filter4 }}</span>枚</p>
              <p class="sub-num">≈<span class="num">{{ antCoinMoney | filter2 }}</span>元</p>
            </div>
          </div>

        </div>
      </van-tab>
      <van-tab class="wallet-tab" title="点卡">
        <div class="list-con">
          <div class="list list3" @click="goWalletLiveCard">
            <div class="img-con">
              <img class="img" :src="checkQiNiuUrl('Fnr98KY9-g2bzAN4M3Bu3Apgi5XS')" alt="">
            </div>
            <div class="text-con">直播充值管理</div>
            <div class="num-con">
              <p class="sup-num"><span class="num">{{ liveCardBalance | filter2 }}</span>元</p>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <van-popup
        v-model="noPhone"
        round
        :close-on-click-overlay="false"
        :style="{width: '90%'}"
    >
      <bind-phone @savePhone="savePhone" />
    </van-popup>

    <van-popup
        v-model="setWalletPass"
        round
        :close-on-click-overlay="false"
        :style="{width: '88%'}"
    >
      <set-wallet-pass @setPass="setPass" />
    </van-popup>



  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getLiveCardInfo } from '@/api/im/liveCard'
import { getCashWallet, serviceWallet } from '@/api/wallet/cash'
import { platformCoin, getAntIntegralWallet } from '@/api/wallet/integral'
import { getWaitSettle } from '@/api/mall/mallSettle'
import bindPhone from '@/components/bindPhone'
import setWalletPass from '@/components/setWalletPass'
export default {
  components: {
    bindPhone,
    setWalletPass,
  },
  data () {
    return {
      walletActive: 0,
      userOpenId: this.session('userOpenId'),
      cashBalance: 0, //现金余额
      productCode: 'AntCoin', // 金币代码
      antCoinBalance: 0, // 金币数量 AntCoin
      sellPriceBenefit: 0, // 金币单价
      antCoinMoney: 0, // 金币 约等于 money
      hasPayPassword: false,
      liveCardBalance: 0, // 直播点卡余额
      noPhone: false,// 是否 没有手机号

      setWalletPass: false,//设置钱包密码

      serviceCash: null,//服务商钱包
      serviceCashTotalAmount: 0,//服务商钱包余额
      waitSettle: 0,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),

    totalAssets (){ //总资产
      return (this.antCoinBalance * this.sellPriceBenefit + this.cashBalance).toFixed(2)
    }
  },
  created() {
    this.$store.dispatch('my/getMyUserInfo') // 获取用户信息
    this.getWaitSettle()
  },
  watch: {
    userInfo(data){
      // console.log(data)
      if(!data.phone){ //判断用户信息中是否有手机号
        this.noPhone = true
      }else {
        this.myBalance() // 获取钱包信息
      }
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    goWalletCash(walletType) {
      this.$router.push({name: 'cash', query: {walletType} })
    },

    goWalletCoin() {
      this.$router.push({name: 'coin'})
    },
    goWalletLiveCard() {
      this.$router.push({name: 'liveCard'})
    },
    goWalletSetting() {
      this.$router.push({name: 'walletSetting'})
    },

    myBalance(msg){
      //获取服务余额信息
      serviceWallet({userOpenid: this.userOpenId, walletType: 2}).then(res=>{
        if(res.data){
          this.serviceCash = res.data
          this.serviceCashTotalAmount = res.data.totalAmount || 0;
        }else {
          console.log('该用户无服务钱包。')
        }
      })
      //获取平台金币信息
      platformCoin().then(res => {
        if(res.code===200){
          this.productCode = res.data.code;  //金币代码
          this.sellPriceBenefit = res.data.sellPriceBenefit; //金币单价
          this.getMyCoin(this.userOpenId, this.productCode)
        }
      })
      //获取现金余额信息
      getCashWallet({userOpenid: this.userOpenId, walletType:0}).then(res => {
        if(res.code===200){
          this.cashBalance = res.data.totalAmount
          // this.session('hasPayPassword', res.data.payPassword)
          if(res.data.payPassword !== '1'){ //没有密码
            this.$toast('请设置支付密码!')
            console.log('方法名： getCashWallet，跳转至设置钱包密码')
            this.setWalletPass = true;
            if(msg==='bindPhoneOK'){//避免该提示被遮挡，故放此位置执行
              this.$toast('绑定手机成功！')
            }
            // this.$router.replace({name: 'passSet'})
          }
        }
      })
      //获取直播余额信息
      getLiveCardInfo({userOpenid: this.userOpenId, userType:0}).then(res=>{
        this.liveCardBalance = res.data.amount || 0;
      })
    },
    //获取金币余额信息
    getMyCoin(userOpenId, productCode){
      getAntIntegralWallet({userOpenid: userOpenId, code: productCode,walletType:0}).then(res => {
        this.antCoinBalance = res.data.totalAmount
        this.antCoinMoney = res.data.totalAmount * this.sellPriceBenefit
      })
    },


    // 子组件 bindPhone 触发的方法
    savePhone(data){
      if(data==='ok'){
        this.noPhone = false;
        this.myBalance('bindPhoneOK') //触发钱包查询接口
      }
    },
    // 子组件 setWalletPass 触发的方法
    setPass(data){
      if(data==='ok'){
        this.setWalletPass = false
        this.myBalance() //触发钱包查询接口
      }
    },

    // 获取待结算
    getWaitSettle(){
      let req = {
        targetId: this.session('userOpenId'),
        targetType: 0,
      }
      getWaitSettle(req).then(res=>{
        this.waitSettle = res.data || 0
      })
    },
  }
}
</script>

<style scoped lang="less">
@url: 'https://fileqn.anttalk.vip/';
.wallet{
  .wallet-header{
    background-color: transparent;
    position: absolute;
    z-index: 9;
    width: 100%;
    .van-nav-bar__left{
      .van-icon{
        color: #fff !important;
      }
    }
    .van-nav-bar__title{
      color: #fff;
    }
    .van-nav-bar__right{
      right: 0;
    }
    .set-icon{
      display: block;
      width: 46px;
      height: 46px;
      background: url("@{url}Fmb9BcwM3LvXswcg6ZRR1WyFb5lS") no-repeat 50% 50%;
      background-size: 22px;
    }
  }

  .header{
    background: url("@{url}FukyP_m6y_-1U9VFmnsfXGipQAlE") no-repeat 50% 0;
    background-size: 100%;
    height: 196px;
    position: relative;
    text-align: center;
    color: white;
    padding-top: 82px;
    display: flex;
    .item{
      flex: 1;
      .title{
        line-height: 1;
        font-size: 13px;
        padding-bottom: 7px;
      }
      .num{
        font-size: 16px;font-weight: bold;
      }
    }
  }
  .wallet-tabs{
    .wallet-tab{
      padding-top: 20px;
    }
  }
  .list-con{
    .list{
      width: 352px;
      height: 70px;
      margin:0 auto 10px;
      border-radius: 5px;
      display: flex;
      font-size: 16px;
      color: white;
      background: url("@{url}Fg4EYij9nN1Ir9PkiZlGWvBqP43d") no-repeat 333px 50%;
      background-size: 8px;
      .img-con{
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        .img{
          width: 46px;
          height: 46px;
        }
      }
      .text-con{
        display: inline-flex;
        align-items: center;
      }
      .num-con{
        flex: 1;
        display: inline-flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: column;
        padding-right: .8rem;
        max-width: 5rem;
        .num{
          padding: 0 6px;
        }
        .sup-num{
          max-width: 5rem;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-size: 16px;
        }
        .sub-num{
          font-size: 10px;
        }
      }
    }
    .list1{
      background-color: #2b86cc;
    }
    .list4{
      background-color: #7d7dde;
    }
    .list2{
      background-color: #dfaa4e;
    }
    .list3{
      background-color: #0b9cc1;
    }

  }
}
</style>
<style lang="less">
.wallet{
  .vux-header{
    .vux-header-left{
      .left-arrow:before{
        border: 1px solid #fff;
        border-width: 1px 0 0 1px;
      }
    }
    .vux-header-title{
      color: white;
    }
  }
  .wallet-tabs{
    .van-tab{font-size: 16px;}
    .van-tabs__wrap{
      z-index: 9;
      /*right: 0;*/
      .van-tabs__line{
        background-color: #2590e2;
      }
    }
  }
}
</style>
